/*
 * @Author: your name
 * @Date: 2020-07-15 13:39:09
 * @LastEditTime: 2020-07-15 13:44:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web-login\src\config\env.js
 */
/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl = ''
let routerMode = 'history'
let baseImgPath = ''
let baseWebSocketPath = ''

if (process.env.NODE_ENV === 'development') {
  // baseUrl = 'http://192.168.32.106:80'
  // baseImgPath = 'http://192.168.32.106:80'
  // baseWebSocketPath = '192.168.32.106:8005'
  baseUrl = 'http://192.168.32.110'
  baseImgPath = 'http://192.168.32.110'
  baseWebSocketPath = '192.168.32.110'
  // baseUrl = 'http://192.168.32.133'
  // baseImgPath = 'http://192.168.32.133'
  // baseWebSocketPath = '192.168.32.133'
  // baseUrl = 'http://39.97.196.199'
  // baseImgPath = 'http://39.97.196.199'
  // baseWebSocketPath = '39.97.196.199'
  // 192.168.36.173
} else {
  baseUrl = window.location.protocol + '//' + window.location.host
  baseImgPath = window.location.protocol + '//' + window.location.host
  baseWebSocketPath = window.location.host
}
export {
  baseUrl,
  routerMode,
  baseImgPath,
  baseWebSocketPath
}



// WEBPACK FOOTER //
// ./src/config/env.js